import React from 'react';
import PropTypes from 'prop-types';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow 
} from '@mui/material';

import AcTableCell from './AcTableCell';
import DcTableCell from './DcTableCell';

const LessRentPaid = ({data}) => {

  const {
    acSockets,
    dcSockets,
    acRentApplicable,
    dcRentApplicable,
  } = data;

  // const hasAC = true;
  const hasAC = acSockets > 0;

  // const hasDC = true;
  const hasDC = dcSockets > 0;

  return (
    <div className="mb-6">
      <TableContainer        
        aria-label="ProfitShareRevenue" 
        sx={{
          borderCollapse: 'separate',
          borderRadius: '15px',
          border: '1px solid rgb(224, 224, 224)',
       }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <AcTableCell hasAC={hasAC} hasDC={hasDC} header data={'AC Sockets'}/>
              <DcTableCell hasAC={hasAC} hasDC={hasDC} header data={'DC Sockets'}/>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Less rent paid</TableCell>
              <AcTableCell hasAC={hasAC} hasDC={hasDC} data={`£${acRentApplicable.toFixed(2)}`}/>
              <DcTableCell hasAC={hasAC} hasDC={hasDC} data={`£${dcRentApplicable.toFixed(2)}`}/>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default LessRentPaid;

LessRentPaid.propTypes = {
  data: PropTypes.object.isRequired,
};
